$(document).ready(function () {
	// On cible tous les boutons ayant [data-open-bigmenu]
	$('[data-open-bigmenu]').on('click', function() {
		const menuId = $(this).attr('data-menu-id');
		const cur = $(this); //rem this later
		// On ferme tous les menus déjà ouverts
		$('.big-menu.active').removeClass('active');
		$('.master-menu').removeClass('big-active');

		$('.big-open').removeClass('big-open');
		

		// On ouvre le menu correspondant
		const $menuToShow = $('.big-menu[data-menu-id="' + menuId + '"]');
		if ($menuToShow.length) {
			$menuToShow.addClass('active');
			$('.master-menu').addClass('big-active');
			cur.closest("li").addClass('big-open');
		}
	});

	// Gestion du clic sur le fond du menu pour fermer
	$('.big-menu').on('click', function(e) {
		// On ferme seulement si on clique sur le fond (pas sur le contenu)
		if (e.target === this) {
			$(this).removeClass('active');
			$('.master-menu').removeClass('big-active');
			$('.big-open').removeClass('big-open');
		}
	});

	// Bouton pour ouvrir/fermer la sidenav mobile
	$('.open-button').on('click', function() {
		if( $('.partials-sidenav').hasClass('mobile-opened') ){
			$('body').removeClass('menu-opened');
			$('.partials-sidenav').removeClass('mobile-opened');
			$('.big-menu').removeClass('active');
			$('.partials-big-menu-mobile-third-panel').removeClass('show');
		}else{
			$('.partials-sidenav').addClass('mobile-opened');
			$('body').addClass('menu-opened');
		}
	});

	$('.partials-sidenav-tablet-bg').on('click', function() {
		$('body').removeClass('menu-opened');
		$('.partials-sidenav').removeClass('mobile-opened');
		$('.big-menu').removeClass('active');
		$('.partials-big-menu-mobile-third-panel').removeClass('show');
	});

	// Gestion des liens de sous-menu mobile
	$('.imi-link[data-menu-target]').on('click', function(e) {

		const menuId = $(this).attr('data-menu-target');
		const $menuContent = $('.big-menu .elements-big-menu-items-loop[data-tmenu-id="' + menuId + '"]');

		const $pbmmContent = $('.pbmm-content');
		if ($pbmmContent.length && $menuContent.length) {
			$pbmmContent.empty();
			$pbmmContent.append($menuContent.clone());
		}
		$('.partials-big-menu-mobile-third-panel').addClass('show');
		const backtext = $(this).closest(".ls-stage-top-mobile").find(".lss-group-tag").text();
		$('.partials-big-menu-mobile-third-panel .backlink-text').html(backtext);
	});
	$(".partials-big-menu-mobile-third-panel .backlink-btn").click(function(e){
		$(this).closest(".partials-big-menu-mobile-third-panel").removeClass("show");
	});

	$(".big-menu .backlink-btn").click(function(e){
		$(this).closest(".big-menu").removeClass("active");
		$('.master-menu').removeClass('big-active');
	});
});


